<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          :value="reportParameters[0].value"
          @input="updateOpticalEquipmentFields"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              startingPointFieldDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "CablesReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        }
      ],

      historyFilter: "pdf_cable"
    };
  },

  computed: {
    startingPointFieldDisabled() {
      return this.selectedWorkspace === undefined;
    },
    buttonsDisabled() {
      if (this.reportParameters[0] && this.reportParameters[0].value) {
        return this.reportParameters[0].value.length === 0;
      }
      return true;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: [
            {
              uuid: this.reportParameters[0].value,
              object_type: "technical_local"
            }
          ]
        }
      };
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.networkStartingPointOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    updateOpticalEquipmentFields(e) {
      this.reportParameters[0].value = e;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/Cables.vue